// validators/tuple.ts
import { assertValidation, ValidationError } from "../errors.mjs";
import { registry } from "../registry.mjs";
import { AbstractValidator } from "../types.mjs";
import { getValidator } from "../utilities.mjs";
var TupleValidator = class extends AbstractValidator {
  members;
  tuple;
  constructor(tuple2) {
    super();
    const members = [];
    for (const item of tuple2) {
      if (item === null) {
        members.push({ single: true, validator: getValidator(null) });
      } else if (typeof item === "object" && Symbol.justusRestValidator in item) {
        members.push({ single: false, validator: item[Symbol.justusRestValidator] });
      } else {
        members.push({ single: true, validator: getValidator(item) });
      }
    }
    this.members = members;
    this.tuple = tuple2;
  }
  validate(value, options) {
    assertValidation(Array.isArray(value), 'Value is not an "array"');
    if (this.members.length === 0) {
      const size = value.length;
      assertValidation(size === 0, `Found ${size} element${size === 1 ? "" : "s"} validating empty tuple`);
      return value;
    }
    const clone = new Array(value.length);
    let needle = 0;
    let haystack = 0;
    let { single, validator } = this.members[needle];
    while (needle < this.members.length && haystack < value.length) {
      try {
        clone[haystack] = validator.validate(value[haystack], options);
        if (single) ({ single, validator } = this.members[++needle] || {});
        haystack++;
      } catch (error) {
        if (single) throw new ValidationError(error, [haystack]);
        else ({ single, validator } = this.members[++needle] || {});
      }
    }
    while (needle < this.members.length && this.members[needle].single === false) {
      needle++;
    }
    const missing = this.members.length - needle;
    if (missing === 1 && single) {
      throw new ValidationError("Tuple defines 1 missing validation");
    } else if (missing > 1) {
      throw new ValidationError(`Tuple defines ${missing} missing validations`);
    }
    const extra = value.length - haystack;
    assertValidation(extra === 0, `Found ${extra} extra element${extra === 1 ? "" : "s"} in tuple`);
    return clone;
  }
};
function tuple(tuple2) {
  return new TupleValidator(tuple2);
}
registry.set("tuple", TupleValidator);
export {
  TupleValidator,
  tuple
};
//# sourceMappingURL=tuple.mjs.map
